import React from "react";
import Close from "../SVGIcons/Close";
import { Transition } from "@headlessui/react";

const Modal = ({
  className,
  children,
  open,
  setOpen,
}: {
  className?: string;
  children: React.ReactNode;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <>
      <Transition
        className="fixed inset-0 z-[40] flex h-screen w-screen items-center justify-center bg-black/30"
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            setOpen(false);
          }
        }}
        show={open}
        as="div"
        appear={true}
        enter="transition-opacity duration-[200ms]"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-[200ms]"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className={`${className} relative px-4 md:px-0`}>
          <Close
            className="absolute right-[35px] top-[20px] size-[18px] cursor-pointer fill-grayscale-solid-g10 hover:fill-blue-solid-blue6 sm:right-[20px]"
            onClick={() => setOpen(false)}
          />
          {children}
        </div>
      </Transition>
    </>
  );
};

export default Modal;
